import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";
import { StateService } from "common";
import {
  DashboardContentComponentData,
  DashboardContentComponentState,
} from "./dashboard-content.model";

const initialState: DashboardContentComponentState = null;

@Injectable({
  providedIn: "root",
})
export class DashboardContentStateService extends StateService<DashboardContentComponentState> {
  constructor() {
    super(initialState);
  }

  getDataSnapshot(): DashboardContentComponentData {
    return this.state?.data;
  }

  getData$(): Observable<DashboardContentComponentData> {
    return this.select((state: DashboardContentComponentState) => state?.data)
    .pipe(
      distinctUntilChanged(),
    );
  }

  setData(data: DashboardContentComponentData): void {
    this.setState({
      ...this.state,
      data,
    });
  }

  clearState(): void {
    super.clearState(initialState);
  }
}
